var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWebTracking = function SvgWebTracking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_webtracking",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "insights_FILL0_wght300_GRAD-25_opsz20",
    d: "M66.106-775.435a1.1,1.1,0,0,1-.811-.337,1.117,1.117,0,0,1-.333-.815,1.107,1.107,0,0,1,.332-.809,1.1,1.1,0,0,1,.813-.335.774.774,0,0,1,.216.03q.105.03.212.068l4-4a1.121,1.121,0,0,1-.062-.216,1.255,1.255,0,0,1-.021-.227,1.1,1.1,0,0,1,.337-.811,1.115,1.115,0,0,1,.815-.334,1.1,1.1,0,0,1,.809.338,1.11,1.11,0,0,1,.335.811,1.269,1.269,0,0,1-.084.411l2.64,2.641q.1-.027.2-.055a.743.743,0,0,1,.209-.029.744.744,0,0,1,.211.03q.1.03.2.068l2.64-2.64a1.372,1.372,0,0,1-.07-.2.816.816,0,0,1-.029-.218A1.1,1.1,0,0,1,79-782.87a1.115,1.115,0,0,1,.815-.334,1.1,1.1,0,0,1,.809.339,1.116,1.116,0,0,1,.335.813,1.1,1.1,0,0,1-.334.811,1.106,1.106,0,0,1-.811.333.817.817,0,0,1-.218-.029,1.369,1.369,0,0,1-.2-.07l-2.64,2.64q.038.1.068.2a.755.755,0,0,1,.03.214,1.1,1.1,0,0,1-.339.813,1.12,1.12,0,0,1-.813.332,1.105,1.105,0,0,1-.811-.332,1.1,1.1,0,0,1-.333-.813,1.114,1.114,0,0,1,.021-.216,1.276,1.276,0,0,1,.062-.213l-2.625-2.625a1.268,1.268,0,0,1-.213.062,1.1,1.1,0,0,1-.213.021,2.018,2.018,0,0,1-.411-.068l-4,4q.027.107.047.2a1,1,0,0,1,.021.208,1.1,1.1,0,0,1-.339.813A1.12,1.12,0,0,1,66.106-775.435Zm.842-7.486-.318-.7-.7-.318.7-.321.318-.7.321.7.7.321-.7.318Zm8.325-.2-.533-1.21-1.21-.533,1.21-.533.533-1.214.533,1.214,1.214.533-1.214.533Z",
    transform: "translate(-43.962 879.025)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebTracking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webTracking.b482bfbf.svg";
export { ForwardRef as ReactComponent };